import { DrawerProps } from '../components';

export enum ACTION {
  CLOSE_ALL_DRAWERS = 'CLOSE_ALL_DRAWERS',
  POP_STATE_FROM_DRAWER_STACK = 'POP_STATE_FROM_DRAWER_STACK',
  PUSH_STATE_TO_DRAWER_STACK = 'PUSH_STATE_TO_DRAWER_STACK',
  SET_STATUS = 'SET_STATUS',
  UPDATE_DRAWER_STACK = 'UPDATE_DRAWER_STACK',
}

type JSXElementCallback = () => JSX.Element;

export type DrawerNavigationState = {
  drawerStack: DrawerState[];
  hasOpenDrawers: boolean;
};

export type DrawerStackContext = {
  drawerStack: DrawerState[];
  hasOpenDrawers: boolean;
  closeAllDrawers: () => void;
  popStateFromStack: (id) => void;
  pushStateToStack: (drawerStackItem: DrawerState) => void;
  updateDrawerStack: (drawerStackItem: DrawerStateUpdate) => void;
};

export type DrawerState = DrawerProps & {
  id: string;
};

export type DrawerStateUpdate = {
  children?: DrawerProps['children'];
  footer?: DrawerProps['footer'];
  header?: DrawerProps['header'];
  headerIcon?: DrawerProps['headerIcon'];
  id: string;
  open: DrawerProps['open'];
  title: DrawerProps['title'];
};
